export const defaultTheme = {
    'white': '#FAFAFA',
    'white-100': '#F3F2F2',
    'white-200': '#E6E5E5',
  
    'gray-100': '#F1E9C9',
    'gray-200': '#8D8686',
    'gray-300': '#574F4D',
    'gray-400': '#403937',
    'gray-800': '#272221',

    'purple-100': '#EBE5F9',
    'purple-300': '#8047F8',
    'purple-500': '#4B2995'
}